import React from "react";
import { FaRedo } from "react-icons/fa";

import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import ScrollIndicator from "../../Home/ScrollIndicator";
import useScrollToTop from "../../../hooks/useScollToTop";

import AdherentGradeSelector from "./components/AdherentGradeSelector";
import BeltFormCard from "./components/BeltFormCard";
import BeltHistoryTimeline from "./components/BeltHistoryTimeline";
import CurrentBeltCard from "./components/CurrentBeltCard";
import DanGradeModal from "./components/DanGradeModal";
import DanGradePanel from "./components/DanGradePanel";
import GradeHero from "./components/GradeHero";
import GradeStats from "./components/GradeStats";
import PassageGradeEmptyState from "./components/PassageGradeEmptyState";
import PassageGradeSkeleton from "./components/PassageGradeSkeleton";

import { usePassageGradePage } from "./hooks/usePassageGradePage";

function PassageGrade() {
  useScrollToTop();

  const {
    adherents,
    selectedAdherentId,
    selectedAdherent,
    grades,
    belts,
    lastGrade,
    gradeCN,
    beltForm,
    gradeCNForm,
    selectedGrade,
    loading,
    refreshing,
    savingBelt,
    savingDan,
    creatingDan,
    deletingBeltIds,
    deletingDan,
    isDanModalOpen,
    stats,
    fetchData,
    handleSelectAdherent,
    handleBeltInputChange,
    handleSubmitBelt,
    handleEditBelt,
    handleCancelBeltEdit,
    handleDeleteBeltWithConfirm,
    handleCreateDanGrade,
    handleOpenDanModal,
    handleCloseDanModal,
    handleGradeCNInputChange,
    handleSaveDanGrade,
    handleDeleteDanWithConfirm,
  } = usePassageGradePage();

  return (
    <main className="min-h-screen bg-slate-50 pb-24 pt-[88px] text-slate-950 dark:bg-slate-950 dark:text-white lg:pt-[104px]">
      <GradeHero stats={stats} lastGrade={lastGrade} />

      <section className="mx-auto -mt-12 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <div className="rounded-[2rem] border border-white/80 bg-white/95 p-4 shadow-2xl shadow-slate-200/70 backdrop-blur-xl dark:border-white/10 dark:bg-slate-900/95 dark:shadow-black/30 sm:p-6">
          <div className="flex flex-col gap-5 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-orange-100 px-3 py-2 text-xs font-bold uppercase tracking-[0.16em] text-orange-700 dark:bg-orange-500/10 dark:text-orange-200">
                Progression technique
              </div>

              <h1 className="mt-4 font-titre text-3xl font-bold tracking-tight text-slate-950 dark:text-white sm:text-4xl">
                Passage de grades
              </h1>

              <p className="mt-3 max-w-3xl text-sm font-medium leading-7 text-slate-600 dark:text-white/60 sm:text-base">
                Suis l'historique des ceintures, ajoute un passage de grade et
                prépare le suivi des UV pour la ceinture noire ou les Dans.
              </p>
            </div>

            <button
              type="button"
              onClick={fetchData}
              disabled={refreshing || !selectedAdherentId}
              className="inline-flex min-h-12 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-bold text-slate-700 transition hover:-translate-y-0.5 hover:border-orange-200 hover:text-orange-700 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/10 dark:bg-white/[0.05] dark:text-white dark:hover:border-orange-300/40 dark:hover:text-orange-100 lg:min-w-[220px]"
            >
              <FaRedo className={refreshing ? "animate-spin" : ""} />
              {refreshing ? "Actualisation..." : "Actualiser"}
            </button>
          </div>

          <GradeStats stats={stats} lastGrade={lastGrade} gradeCN={gradeCN} />
        </div>
      </section>

      <section className="mx-auto mt-6 w-full max-w-[1280px] px-4 sm:px-6 lg:px-8">
        <AdherentGradeSelector
          adherents={adherents}
          selectedId={selectedAdherentId}
          onSelect={handleSelectAdherent}
        />

        {loading ? (
          <PassageGradeSkeleton />
        ) : !selectedAdherent ? (
          <PassageGradeEmptyState />
        ) : (
          <>
            <div className="grid gap-5 lg:grid-cols-[1.35fr_0.65fr]">
              <BeltHistoryTimeline
                grades={grades}
                deletingIds={deletingBeltIds}
                onEdit={handleEditBelt}
                onDelete={handleDeleteBeltWithConfirm}
              />

              <div className="space-y-5">
                <CurrentBeltCard lastGrade={lastGrade} />

                <BeltFormCard
                  belts={belts}
                  form={beltForm}
                  selectedGrade={selectedGrade}
                  saving={savingBelt}
                  onChange={handleBeltInputChange}
                  onSubmit={handleSubmitBelt}
                  onCancel={handleCancelBeltEdit}
                />
              </div>
            </div>

            <div className="mt-6">
              <DanGradePanel
                lastGrade={lastGrade}
                gradeCN={gradeCN}
                creating={creatingDan}
                deleting={deletingDan}
                onCreate={handleCreateDanGrade}
                onEdit={handleOpenDanModal}
                onDelete={handleDeleteDanWithConfirm}
              />
            </div>
          </>
        )}
      </section>

      <DanGradeModal
        isOpen={isDanModalOpen}
        form={gradeCNForm}
        gradeCN={gradeCN}
        saving={savingDan}
        onClose={handleCloseDanModal}
        onChange={handleGradeCNInputChange}
        onSubmit={handleSaveDanGrade}
      />

      <DashboardNavigation />
      <ScrollIndicator />
    </main>
  );
}

export default PassageGrade;